import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";

import { ReactComponent as Arrow } from "../../assets/icons/arrow.svg";
import { useEffect, useRef, useState } from "react";
import BackButton from "components/common/buttons/basicButton/BackButton";
import styled from "styled-components";
import { useSelector } from "react-redux";
import NewButton, {
  NewButtonSize,
  NewButtonVariant,
} from "components/common/buttons/basicButton/NewButton";
import { useNavbarContext } from "../../hooks/useNavbarContext";
import OpenMenuIcon from "../../assets/icons/OTWORZ.svg";
import CloseMenuIcon from "../../assets/icons/ZAMKNIJ.svg";

const Test = styled.div`
  & > div {
    width: 100%;
  }
`;

export interface IContentContainerProps {
  TopBar?: JSX.Element;
  title: string;
  path?: string;
  noArrow?: boolean;
  fn?: any;
  isModalOpen?: boolean;
  removeMenuButton?: boolean;
}

interface RouteParams {
  id: string;
}

const ContentContainer: React.FC<IContentContainerProps> = ({
  title,
  children,
  TopBar,
  path = "/",
  noArrow = false,
  fn,
  isModalOpen,
  removeMenuButton = false,
}) => {
  const { goBack, push } = useHistory();
  const topbarRef = useRef<HTMLDivElement>(null);
  const { id } = useParams<RouteParams>();
  const { isNavbarOpen, toggleNavbar, openNavbar, closeNavbar } =
    useNavbarContext();
  const trainerPlayerRouterDetail = useSelector(
    (state: any) => state.radarRouteDetailReducer,
  );

  const isTrainerAvalible = trainerPlayerRouterDetail.isActive;

  const location = useLocation();
  const pathname = location.pathname;

  const [isVisible, setIsVisible] = useState(false);

  const isStructure = pathname === "/structure";

  const goBackPath = isTrainerAvalible
    ? "/outside-trainers/available"
    : pathname.split("/detail")[0] === "/outside-trainers"
    ? "/outside-trainers/requested"
    : pathname.split("/detail")[0];

  useEffect(() => {
    if (id !== undefined) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [id, pathname, isStructure]);

  const changeCssProperty = () => {
    const oldValue =
      document.documentElement.style.getPropertyValue("--topbar-height");

    if (
      topbarRef.current &&
      oldValue !== `${topbarRef.current.clientHeight}px`
    ) {
      document.documentElement.style.setProperty(
        "--topbar-height",
        topbarRef.current.clientHeight + "px",
      );
    }
  };

  useEffect(() => {
    changeCssProperty();
    window.addEventListener("resize", changeCssProperty);

    return () => {
      window.removeEventListener("resize", changeCssProperty);
    };
  }, []);

  useEffect(() => {
    changeCssProperty();
  }, [title]);

  const handleBackClick = () => {
    if (id !== undefined) {
      push(goBackPath);
    } else if (fn) {
      fn();
    } else {
      goBack();
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
      }}
    >
      <Helmet>
        <title>Just Win | {title || ""}</title>
      </Helmet>
      <div
        ref={topbarRef}
        className="flex flex-col md:flex-row items-start justify-between gap-x-2 gap-y-6  sticky top-0 z-30"
        style={{
          background: "rgba(0,0,0,0.5)",
        }}
      >
        <div className="flex items-center gap-x-4 ">
          <div
            style={{
              // borderLeft: "5px solid rgba(163, 158, 157, 0.7)",
              height: "48px",
              display: isModalOpen
                ? "block"
                : isStructure
                ? "block"
                : isVisible
                ? "block"
                : "none",
            }}
          ></div>
          {!removeMenuButton && (
            <NewButton
              onlyIcon
              onClick={toggleNavbar}
              size={NewButtonSize.Medium}
              leftIcon={
                isNavbarOpen ? (
                  <img src={CloseMenuIcon} alt="close" />
                ) : (
                  <img src={OpenMenuIcon} alt="open" />
                )
              }
              variant={NewButtonVariant.Secondary}
              outline
            />
          )}
          <h2
            className="text-opacity-80 text-lg w-max capitalize-first"
            style={{
              color: "#F8F8F8",
              fontWeight: 400,
              fontSize: "18px",
              letterSpacing: "0.1px",
              height: "48px",
              display: "flex",
              alignItems: "center",
              paddingLeft: !isVisible && !isStructure ? "17px" : "",
              // borderLeft: isModalOpen
              //   ? ""
              //   : !isVisible && !isStructure
              //   ? "5px solid rgba(163, 158, 157, 0.7)"
              //   : "",
            }}
          >
            {title}
          </h2>
        </div>
        {TopBar && <div className="w-full h-full">{TopBar}</div>}
      </div>
      <Test
        style={{
          flexGrow: 1,
          display: "flex",
          width: "100%",
          // borderTop: "10px solid rgba(0,0,0,0.5)",
        }}
      >
        {children}
      </Test>
    </div>
  );
};

export default ContentContainer;
